export const APP_DOMAIN: string = 'no1.is'
export const APP_MODULE_NAMES: string[] = [
  'signin',
  'media',
  'news',
]
export const APP_MODULE_DEFAULT_INDEX: number = 0